import { useCallback, useState } from "react";

export const useCloseTooltipsOnModalOpen = () => {
    const [tooltipResetKey, setTooltipResetKey] = useState(0);

    const resetTooltips = useCallback(() => {
        setTooltipResetKey((prev) => prev + 1);
    }, []);

    return { tooltipResetKey, resetTooltips };
};
